import type { Account } from 'entities/user/module'

import { preparePhoneNumber } from 'shared/lib/prepare-phone-number'

import type { BookingFormValues } from '../model'

interface GetBookingContactDefaultValuesParams {
  user?: Account | null
}

export const emptyBookingContactDefaultValues: BookingFormValues = {
  firstName: '',
  lastName: '',
  middleName: '',
  email: '',
  phone: undefined,
  isAgreementAccepted: false,
}

export const getBookingContactDefaultValues = ({
  user,
}: GetBookingContactDefaultValuesParams): BookingFormValues => {
  if (user) {
    return {
      ...emptyBookingContactDefaultValues,
      firstName: user.first_name,
      lastName: user.last_name,
      middleName: user.middle_name ?? '',
      email: user.email || '',
      phone: preparePhoneNumber(user.phone_number),
    }
  }

  return emptyBookingContactDefaultValues
}
